"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrap = wrap;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

function* wrap(source) {
  yield* (0, _iterable.ensureIterable)(source)[Symbol.iterator]();
}

var _default = (0, _iterable.wrapWithMethodIterable)(wrap);

exports.default = _default;